// Static product data — update here when products change on Stripe

interface Product {
  id: string;
  [key: string]: any;
}

export const STATIC_PRODUCTS: Product[] = [
  {
    id: 'one-and-done',
    name: 'Essential Pack',
    description: 'Essential hydration and vitamin blend to keep you feeling your best',
    images: ['/images/lime-tub.webp'],
    unitPrice: 5999,
    priceId: 'price_1Qru79G1x0pR1xxfBdG00Sh0b',
    status: 'active',
    gradients: { from: 'purple', to: 'fuchsia' },
    shippingCost: 0,
    order: 0,
    metadata: {
      flavor: 'Lime Squash',
      flavorSelections: 1,
      servings: 25,
      weight: '100g',
      freeShipping: true,
      tier: 'Basic',
      availableFlavors: ['Lime Squash', 'Orange Crush', 'Pineapple Punch']
    }
  },
  {
    id: 'dynamic-duo',
    name: 'Dynamic Pack',
    description: 'Double up with two tubs for steady hydration and support',
    images: ['/images/lime-tub.webp'],
    unitPrice: 9999,
    priceId: 'price_1Qru79G1x0pR1xxfhAvYaHwe',
    status: 'active',
    gradients: { from: 'blue', to: 'fuchsia' },
    shippingCost: 0,
    order: 1,
    metadata: {
      flavor: 'Orange Crush',
      flavorSelections: 2,
      servings: 40,
      weight: '250g',
      freeShipping: true,
      tier: 'Popular',
      availableFlavors: ['Lime Squash', 'Orange Crush', 'Pineapple Punch']
    }
  },
  {
    id: 'triple-threat',
    name: 'Triple Pack',
    description: 'The full bundle to stay stocked, hydrated, and ready',
    images: ['/images/lime-tub.webp'],
    unitPrice: 12999,
    priceId: 'price_1Qru79G1x0pR1xxftq0HFfDr',
    status: 'active',
    gradients: { from: 'purple', to: 'fuchsia' },
    shippingCost: 0,
    order: 2,
    metadata: {
      flavor: 'Mixed Pack',
      flavorSelections: 3,
      servings: 60,
      weight: '300g',
      freeShipping: true,
      tier: 'Premium',
      availableFlavors: ['Lime Squash', 'Orange Crush', 'Pineapple Punch']
    }
  }
];

// Global state for preloaded data
const preloadedData = {
  products: [] as Product[],
  productsLoaded: false,
  loading: true
};

// Minimum loading time to prevent flickering (ms)
const MIN_LOADING_TIME = 500;
const loadingStartTime = Date.now();

// Callback to track when updates happen
type PreloadUpdateCallback = () => void;
const updateCallbacks: PreloadUpdateCallback[] = [];

// Helper to notify callbacks
const notifyCallbacks = () => {
  updateCallbacks.forEach(callback => callback());
};

// Subscribe to preload updates
export const subscribeToPreloadUpdates = (callback: PreloadUpdateCallback) => {
  updateCallbacks.push(callback);
  return () => {
    const index = updateCallbacks.indexOf(callback);
    if (index !== -1) {
      updateCallbacks.splice(index, 1);
    }
  };
};

// Initialize preloading of product data
export const initializePreloading = () => {
  preloadedData.products = STATIC_PRODUCTS;
  preloadedData.productsLoaded = true;
  checkLoadingComplete();
  notifyCallbacks();

  // Ensure loading state respects minimum loading time
  setTimeout(() => {
    checkLoadingComplete();
    notifyCallbacks();
  }, MIN_LOADING_TIME);
};

// Check if all loading is complete
const checkLoadingComplete = () => {
  const elapsedTime = Date.now() - loadingStartTime;
  const shouldCompleteLoading = preloadedData.productsLoaded && elapsedTime >= MIN_LOADING_TIME;

  if (shouldCompleteLoading && preloadedData.loading) {
    preloadedData.loading = false;
    notifyCallbacks();
  }
};

// Get preloaded data
export const getPreloadedData = () => {
  return {
    ...preloadedData,
    isReady: !preloadedData.loading
  };
};
